import React, { useEffect, useRef, useState } from "react";
import { Col, Row } from "react-bootstrap";
import styles from "./Settings.module.css"
import { useDispatch, useSelector } from "react-redux";
import { addEditPoste, getPostesSettings, removePoste } from "./settingsSlice";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import Langs from "../../app/lang/langs";
import { InputSwitch } from "primereact/inputswitch";
import { showErrorToast, showSuccessToast } from "../../app/utils/helpers";
import ImageButton from "../../components/buttons/ImageButton";
import addIcon from '../../assets/images/add.png'
import addIconFocus from '../../assets/images/addFocus.png'
import deleteIcon from '../../assets/images/delete.png'
import deleteIconFocus from '../../assets/images/delete-orange.png'
import AddPosteModal from "./Modals/AddPosteModal";
import { ConfirmDialog, confirmDialog } from 'primereact/confirmdialog';
import { InputText } from "primereact/inputtext";
import editIcon from '../../assets/images/edit.png'
import editIconFocus from '../../assets/images/editFocus.png'
import xIcon from "../../assets/images/reject.png";
import xIconFocus from "../../assets/images/rejectDanger.png";
import checkIcon from "../../assets/images/check.png";
import checkIconFocus from "../../assets/images/checkSuccess.png"
import { current } from "@reduxjs/toolkit";

export default function PostesTab() {

    const dispatch = useDispatch()

    const postesSlice = useSelector((state) => state.settings.postes)


    const [postes, setPostes] = useState([]);
    const [addModalVisible, setAddModalVisible] = useState(false)
    const [onEditPost, setOnEditPoste] = useState(null)
    const [onEditName, setOnEditName] = useState('')

    const mounted = useRef(null);

    useEffect(() => { setPostes(postesSlice) }, [postesSlice])

    useEffect(() => {
        if (!mounted.current) {
            mounted.current = true
        }
        dispatch(getPostesSettings())
    }, [mounted]);

    const handleActivatePoste = (e, rowData) => {
        if (e.value === true) {
            setPostes(
                postes.map(p => {
                    if (p.id === rowData.id) {
                        return {
                            ...p,
                            active: 1,
                        }
                    }
                    return p
                })
            )
            dispatch(addEditPoste({ id: rowData.id, active: 1 })).then((actionResponse) => {
                if (addEditPoste.fulfilled.match(actionResponse)) {
                    if (actionResponse.payload.responseData && actionResponse.payload.responseData.status) {
                        dispatch(getPostesSettings());
                        showSuccessToast("Poste activé")
                    }
                }
                if (actionResponse.payload.responseData.status === 0) {
                    showErrorToast(actionResponse.payload.responseData.message);
                }
            })
        };
        if (e.value === false) {
            setPostes(
                postes.map(p => {
                    if (p.id === rowData.id) {
                        return {
                            ...p,
                            active: 0,
                        }
                    }
                    return p
                })
            )
            dispatch(addEditPoste({ id: rowData.id, active: 0 })).then((actionResponse) => {
                if (addEditPoste.fulfilled.match(actionResponse)) {
                    if (actionResponse.payload.responseData && actionResponse.payload.responseData.status) {
                        dispatch(getPostesSettings());
                        showErrorToast("Poste désactivé")
                    }
                }
                if (actionResponse.payload.responseData.status === 0) {
                    showErrorToast(actionResponse.payload.responseData.message);
                }
            })
        };
    }

    const toggleActive = (rowData) => {
        return (
            <div className="d-flex justify-content-start">
                <InputSwitch
                    checked={rowData.active == 1}
                    onChange={(e) => { handleActivatePoste(e, rowData); }}
                />
            </div>
        )
    }
    const deleteButton = (rowData) => {
        return (
            <ImageButton
                image={deleteIcon}
                imageFocus={deleteIconFocus}
                onClick={() => { confirmDelete(rowData.id, rowData.name) }}
                active={true}
                tooltip={<Langs str="DELETE_POSTE" />}
                width={24} />
        )
    }
    const confirmDelete = (id, name) => {
        const accept = () => {
            dispatch(removePoste({ id: id })).then((actionResponse) => {
                if (removePoste.fulfilled.match(actionResponse)) {
                    if (actionResponse.payload.responseData && actionResponse.payload.responseData.status) {
                        dispatch(getPostesSettings());
                        showSuccessToast(actionResponse.payload.responseData.message)
                    }
                }
                if (actionResponse.payload.responseData.status === 0) {
                    showErrorToast(actionResponse.payload.responseData.message);
                }
            })
        }

        const reject = () => {
            return
        }
        const message = (name) => {
            return <p className="my-2"><Langs str="DELETE_POSTE_MESSAGE" /> <b>{name}</b></p>
        }
        confirmDialog({
            message: message(name),
            icon: 'pi pi-exclamation-triangle',
            defaultFocus: 'accept',
            accept,
            reject
        });
    };
    const tableHeader = () => {
        return (
            <div>
                <ImageButton
                    image={addIcon}
                    imageFocus={addIconFocus}
                    onClick={() => { setAddModalVisible(true) }}
                    active={true}
                    tooltip={<Langs str="ADD_POSTE" />}
                    width={24} />
            </div>
        )
    }

    const handleEditPoste = (name, id) => {
        if (name.trim() != '' && id != null) {
            dispatch(addEditPoste({ id: id, name: name }))
            setPostes(current => {
                return current.map(poste => {
                    if (poste.id == id) {
                        return {
                            ...poste,
                            name: name
                        };
                    }
                    return poste;
                });
            });
            setOnEditPoste(null);
            setOnEditName('')
        }
    }

    const editField = () => {
        return (
            <div>
                <InputText value={onEditName} onChange={(e) => setOnEditName(e.target.value)} />
                <ImageButton
                    image={xIcon}
                    imageFocus={xIconFocus}
                    onClick={() => { setOnEditPoste(null); setOnEditName('') }}
                    active={true}
                    tooltip={<Langs str="CANCEL" />}
                    width={18}
                />
                {onEditName.trim() != '' &&
                    <ImageButton
                        image={checkIcon}
                        imageFocus={checkIconFocus}
                        onClick={() => { handleEditPoste(onEditName, onEditPost) }}
                        active={true}
                        tooltip={<Langs str="EDIT_CLIENT" />}
                        width={28}
                    />}
            </div>
        )
    }
    const bodyColumn = (rowData) => {
        return (
            <div className="d-flex justify-content-between">
                {rowData.id == onEditPost ? editField(rowData.name, rowData.id) : rowData.name}
                <ImageButton
                    image={editIcon}
                    imageFocus={editIconFocus}
                    onClick={() => { setOnEditPoste(rowData.id); setOnEditName(rowData.name) }}
                    active={true}
                    tooltip={<Langs str="EDIT" />}
                    width={20}
                />
            </div>
        )
    }

    return (
        <div>
            <Row className="m-0">
                <Col xl={1}>
                </Col>
                <Col xl={8} className="d-flex align-content-center">
                    <div className={styles.menuContent}>
                        <DataTable
                            value={postes}
                            scrollable
                            scrollHeight="calc(85vh)"
                            draggable={false}
                        >
                            <Column field="active" header={<Langs str="ACTIVE" />} body={toggleActive} ></Column>
                            <Column field="name" sortable body={bodyColumn} header={<Langs str="NAME" />} ></Column>
                            <Column field="id" header={tableHeader} body={deleteButton}></Column>
                        </DataTable>
                    </div>
                </Col>
            </Row> 
            
            <AddPosteModal
                visible={addModalVisible}
                setVisible={setAddModalVisible}
            />
        </div>
    )
}